// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"111":"admin-texts","190":"docs","258":"reviews","268":"events","594":"about","781":"admin-staff"}[chunkId] || chunkId) + "." + {"111":"2a0198f4","153":"55d08168","190":"a0139119","258":"1f5854a8","268":"c5e57ad1","594":"c8a36c56","781":"ab77ac02"}[chunkId] + ".css";
};